import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { AppLogoService } from '../../services/app-logo.service';

@Component({
  selector: 'app-modal-header-ui',
  templateUrl: './modal-header-ui.component.html',
  styleUrls: ['./modal-header-ui.component.css'],
})
export class ModalHeaderUiComponent {
  logo$: Observable<string>;

  @Input() subtitle?: string;
  @Input() title: string = '';
  @Input() showCloseBtn: boolean = true;
  /**
   * Drops the mat-dialog-close directive from the X so the host decides
   * whether the dialog actually closes — e.g. to confirm discarding unsaved
   * work first. Without this the directive closes the dialog immediately and
   * any (closeModal) handler runs against an already-dismissed dialog.
   *
   * Defaults to false: most hosts rely on mat-dialog-close alone.
   */
  @Input() confirmBeforeClose: boolean = false;
  @Output() closeModal: EventEmitter<null> = new EventEmitter();

  constructor(
    private appLogoService: AppLogoService,
  ){this.logo$ = this.appLogoService.logo$}

  dismiss() {
    this.closeModal.emit();
  }
  getLocalizedTitle() {
    return $localize`:@@repay_loan:Repay Loan`;
  }


getLocalizedSelectStaff(){
  return $localize`:@@select_staff:Select staff`
}
getLocalizedSelectRole(){
  return $localize`:@@select_role:Select Role`
}
getLocalizedWaiveInterest(){
  return $localize`:@@waive_interest_button:Waive Interest`
}
}
